import { Auditable, QueryParams, SortParams } from "..";

export interface Country extends Auditable {
    name: string;
}

export const DefaultCountryQueryParams: QueryParams = {
    description: "",
    name: "",
};

export const DefaultCountrySortParams: SortParams = {
    orderBy: "name",
    orderDesc: "false",
};
